import Button from "@/types/components/Button.interface"

export default {
    methods: {
        //  Determine is an object is visible, via 'permission' and 'hidden' properties
        isVisible(obj: Button): boolean {
            //  If the object has a 'hidden' property, that overrides all others
            if (obj.hidden) return !obj.hidden

            //  Else, if a 'permission' property is set, we need to handle it
            if (obj.permission) {

                //  If a tenant does NOT exist, we allow 'admin of any' to see everything
                if (!this.$store.getters.tenant) return this.$store.getters.isAdminOfAny

                //  Else, return the user's permission check
                return this.$store.getters.userHasPermission(obj.permission)
            }

            //  Else, no 'hidden' or 'permission' is set, return true
            return true
        }
    }
}